import {mapGetters} from 'vuex';
import {camelCase} from 'lodash';

import {VueSlideToggle} from 'vue-slide-toggle'

export default {
	name		: 'courses-module',
	props		: {
		index: {
			type: Number,
			default: 0
		},
		item: {
			type: Object,
		}
	},
	components	: {
		VueSlideToggle
	},
	data() {
		return {
			open: false,
		}
	},
	created() {
		if (this.index === 1) {
			this.open = true;
		}
	},
	mounted() {
		let {target_slug, module_slug} = this.$route.query;
		
		if (module_slug === this.item.slug) {
			this.open = true;
			
			this.$refs['module'].scrollIntoView();
		}
	},
	computed	: {
		...mapGetters({}),
		totalTimeModule() {
			return this.calculationTimeModule(this.item.duration);
		},
		completedLessons() {
			if (this.item.userModule.data.hasOwnProperty('completedMaterials')) {
				return this.item.userModule.data.completedMaterials
			}
			
			return 0
		},
		completedTimeModule() {
			if (this.item.userModule.data.hasOwnProperty('completedMinutes')) {
				const duration = this.item.userModule.data.completedMinutes;
				
				if (!duration) return 0;
				
				return this.calculationTimeModule(duration);
			}
			
			return 0
		},
		classModule() {
			if(this.item.userModule && this.item.userModule.data){
				if(this.item.userModule.data.status == 'completed'){
					return 'green';
				}
				
				if(this.item.userModule.data.status == 'processing'){
					return 'orange';
				}
			}
			
			return '';
		}
	},
	methods		: {
		getCamelCase(text) {
			return camelCase(text);
		},
		getMaterialItem(material) {
			const typeMaterial = material.material === 'lesson' ? 'userLesson' : 'userHomeWork';
			return material[typeMaterial].data
		},
		declensionWord(count) {
			let titles = [this.$t('point1'), this.$t('point2'), this.$t('point3')];
			let cases = [2, 0, 1, 1, 1, 2];
			return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
		},
		formattedTimeLesson(time) {
			const hours = Math.floor(time / 60);
			const minutes = time % 60;
			return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:00`
		},
		getSpeaker(speaker) {
			return speaker
		},
		calculationTimeModule(duration) {
			const hours = Math.floor(duration / 60);
			const minutes = duration % 60;
			return `${hours} ${this.$t('smHour')}  ${minutes < 10 ? '0' + minutes : minutes}  ${this.$t('smMinutes')}`
		},
		setStatusModuleItem(item) {
			return item.userModule.data.hasOwnProperty('id') ? item.userModule.data.status : 'new'
		},
		setStatusMaterialItem(item) {
			const typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork'
			return item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new'
		},
		romanize(num) {
			var lookup = {
					M: 1000,
					CM: 900,
					D: 500,
					CD: 400,
					C: 100,
					XC: 90,
					L: 50,
					XL: 40,
					X: 10,
					IX: 9,
					V: 5,
					IV: 4,
					I: 1
				},
				roman = '',
				i;
			for (i in lookup) {
				while (num >= lookup[i]) {
					roman += i;
					num -= lookup[i];
				}
			}
			return roman;
		},
		getStatus(item) {
			let cnf = null;
			
			if (item.material === "lesson") {
				cnf = item.userLesson.data;
			} else {
				cnf = item.userHomeWork.data;
			}
			
			return cnf.status
		}
	}
}
